import moment from "moment";
import { Tag } from 'primereact/tag';
import { Message } from 'primereact/message';
import Countdown from 'react-countdown';
import count_days from "../functions/count_days";
import before_days from "../functions/print_date_before_days";
import view_apartment_type_ar from "../functions/view_apartment_type";
import view_day_ar from "../functions/view_day_ar";
import ios from "../public/images/ios.png";
import android from "../public/images/android.png";
import img_waterpark from "../public/images/waterpark_1.png"
import img_table_beach from "../public/images/table_beach.png";
import logo from "../public/images/logo.png";
import bracelet_img from "../public/images/bracelets.png";
import { Badge } from 'primereact/badge';
import { Button } from 'primereact/button';
import API from "../Helper/server/API";
import { _endPoints } from "../Helper/links";
import { toast } from "react-toastify";
export const View_service_img = (item) => {
        if (item?.service_image === 'waterpark') {
                return img_waterpark;
        }
        else if (item?.service_image === 'table_beach') {
                return img_table_beach;
        }
        else {
                return logo;
        }
}
export const view_Apartment = (data) => {
        return (
                <strong >
                        {
                                data?.reservation_type === 'service' ?
                                        <span> {data?.service_name_ar ?? '-'}</span> :
                                        <span>{view_apartment_type_ar(data.type)} - {data.number}</span>
                        }
                        <br></br>
                        {data?.number_people} أشخاص
                </strong>
        )
}
export const View_rule_type = (item) => {
        if (item?.rule_type === 'extra_person') {
                return "إضــافة شخــص"
        }
        else if (item?.rule_type === 'age') {
                return "فئة عمرية"
        }
        else if (item?.rule_type === 'weekend') {
                return "عطلة نهاية الاسبوع"
        }
        else {
                return ""
        }
}
export const View_DeviceSystem = (item) => {
        return (
                <img src={item.system === "android" ? android : ios} alt="" width={40} height={40} />
        )
}

export const View_date_login = (item) => {
        return (
                <p>
                        {before_days(item.date_login)}
                        <br></br>
                        {moment(item.date_login).format("LT")}
                </p>
        );
}
export const View_token_firebase = (item, toast) => {

        return (
                <>
                        {item?.token_firebase && item?.token_firebase !== 'null' ?

                                <>
                                        <Button
                                                dir="ltr"
                                                type="button"
                                                label="إسال إشعار ترحيب"
                                                icon="pi pi-check"
                                                outlined
                                                severity="success"
                                                onClick={async () => {
                                                        const response = await API.post(`${_endPoints.users_app.sendWelcomePushNotification}?id=${item.id}`);
                                                        if (response?.success) {
                                                                if (toast.current) {
                                                                        toast.current.show({ severity: "success", summary: "تم الإرسال", detail: "تم إرسال إشعار الترحيب", life: 3000 });
                                                                } else {
                                                                        console.log("toast is not defined");
                                                                }
                                                        }
                                                        else {
                                                                if (toast.current) {
                                                                        toast.current.show({ severity: "error", summary: "خطأ", detail: response?.msg, life: 3000 });
                                                                } else {
                                                                        console.log("toast is not defined");
                                                                }
                                                        }

                                                }}
                                                style={{ marginRight: "0px" }}
                                        />
                                </>
                                : <>-</>}
                </>
        );
}
export const View_ip_address_login = (item) => {
        return (
                <a dir="ltr" href={`https://iplocation.io/ip/${item.ip_address_login}`} target="_blank" rel="noopener noreferrer">
                        {item.ip_address_login}
                </a>
        );
}
export const View_user_approve = (item) => {
        return (
                <>
                        {item.user_approve ?
                                <Message severity="success" icon="pi pi-check ml-1" text="تم التحقق" />
                                : <Message severity="error" icon="pi pi-times ml-1" text="لم يتم التحقق" />
                        }
                </>
        );
}
export const View_date_logout = (item) => {
        return (
                item.date_logout ?
                        <p>
                                {before_days(item.date_logout)}
                                <br></br>
                                {moment(item.date_logout).format("LT")}
                        </p>
                        : <>-</>
        );
}

export const View_date_create = (item) => {
        return (
                <p>
                        {before_days(item.date_create)}
                        <br></br>
                        {moment(item.date_create).format("LT")}
                </p>
        );
}

export const View_date_created = (item) => {
        return (
                <p>
                        {before_days(item.date_created)}
                        <br></br>
                        {moment(item.date_created).format("LT")}
                </p>
        );
}
export const View_country_code_phone = (item) => {
        return (
                <a
                        style={{ color: 'black' }}
                        href={`tel:+${item.country_code}${item.phone}`}
                        dir="ltr"
                >
                        +{item.country_code}-{item.phone}
                </a>)
}
export const View_control_points = (item) => {
        return (
                <>
                        {item.control_points}  <i className="pi pi-star"></i>
                </>
        )
}
export const View_control_expired = (item) => {
        return (
                item.control_expired && moment(item.control_expired).format("Y-MM-DD") > moment(new Date()).format("Y-MM-DD") ?
                        <Tag style={{ fontSize: "13px" }} severity="danger" dir='ltr' value={moment(item.control_expired).format("Y-MM-DD")}></Tag>
                        : <>-</>
        )
}
export const View_whatsapp_number = (item) => {
        return (
                <>
                        {item.whatsapp_number && item.whatsapp_number !== 'null' ? <><a dir='ltr' href={`https://wa.me/${item.whatsapp_number}`} target="_blank" rel="noopener noreferrer" style={{ color: "black" }}>+{item.whatsapp_number}</a></> : '-'}
                </>
        )
}
export const View_count_logins = (item) => {
        if (item.count_login < 10) {
                return (
                        <Tag style={{ fontFamily: "Cairo", fontSize: "14px" }} severity="contrast" className="pr-4 pl-4" dir='ltr' value={item.count_login}></Tag>
                )
        }
        else {
                return (
                        <Tag style={{ fontFamily: "Cairo", fontSize: "13px" }} severity="danger" className="mr-2" dir='ltr' icon="pi pi-exclamation-triangle" value={item.count_login}></Tag>
                )
        }
}
export const ViewApartment_type_number = (item) => {
        return (
                <>
                        {view_apartment_type_ar(item?.type) + "-" + item?.number + " "}
                </>
        );
};
export const CustomerTemplate = (reservation) => {
        return (
                <>
                        {reservation.visitor_name}
                        <br></br>
                        <a style={{ color: "#495057" }} href={"tel:+218" + reservation.phone_number}>{reservation.phone_number}</a>
                        <br></br>
                        {reservation.whatsapp_number && reservation.whatsapp_number !== "null" ?
                                <>
                                        <a style={{ color: "#495057" }} href={"tel:+" + reservation.whatsapp_number} dir="ltr">{reservation.whatsapp_number}</a>
                                        <i className="fa fa-whatsapp pr-1" style={{ color: "green", width: "2px" }}></i>
                                </>
                                :
                                <></>
                        }
                </>
        );
};
export const ApartmentsViewItemTemplate = (apt) => {
        return (
                <div className="flex align-items-center gap-1" style={{ fontFamily: "Cairo", direction: "rtl" }} >
                        <span>{view_apartment_type_ar(apt?.type)} - {apt?.number}</span>
                </div>
        );
};
export const View_service_name = (item) => {
        return (
                <div className="flex align-items-center gap-1" style={{ fontFamily: "Cairo", direction: "rtl" }} >
                        <span>{item?.service_name_ar}</span>
                </div>
        );
};
export const PaidViewTemplate = (value) => {
        return (
                <>
                        <Tag style={{ fontFamily: "Cairo", direction: "rtl", fontSize: "13px", textAlign: "right", maxHeight: "22px" }}
                                value={value === 'all' ? 'الكل' : value === 'paid' ? "مدفوع" : "غير مدفوع"} severity={value === 'all' ? 'info' : value === 'paid' ? "success" : "danger"}>
                        </Tag>
                </>
        );
};
export const DateDel_BodyTemplate = (reservation) => {
        var diffInMs = new Date(moment(reservation.date_del_reservation).format("yyyy-MM-DD")) - new Date(moment(new Date()).format("yyyy-MM-DD"));
        var diffInDays = diffInMs / (1000 * 60 * 60 * 24);
        return (
                <p>
                        {
                                reservation.date_del_reservation ?
                                        <>
                                                {moment(reservation.date_del_reservation).format("YYYY-MM-DD")}
                                                <br></br>
                                                {moment(reservation.date_del_reservation).format("LT")}
                                                <br></br>
                                                {diffInDays > 0 ? " بـعد " + diffInDays + " آيــام " : null}
                                        </>
                                        : null
                        }
                </p>
        );
};
export const Date_CheckInBodyTemplate = (reservation) => {
        return (
                <>
                        {moment(reservation.date_check_in).format("YYYY-MM-DD")}
                        <br></br>
                        {view_day_ar(reservation.date_check_in)}
                </>
        );
};
export const Date_CheckOutBodyTemplate = (reservation) => {
        return (
                <>
                        {moment(reservation.date_check_out).format("YYYY-MM-DD")}
                        <br></br>
                        {view_day_ar(reservation.date_check_out)}
                </>
        );
};
export const Total_PriceBodyTemplate = (reservation) => {
        return Intl.NumberFormat("en-US").format(reservation.total_price) + " د.ل";
};
export const Total_PaidBodyTemplate = (reservation) => {
        if (reservation.total_paid === 0) {
                return <>-</>
        }
        else if (reservation.card_paid === 1) {
                return <>{Intl.NumberFormat("en-US").format(reservation.total_paid)} د.ل <br></br> <i class="fa fa-credit-card"></i> </>

        }
        else {
                return <>{Intl.NumberFormat("en-US").format(reservation.total_paid)} د.ل </>

        }
};
export const Total_discound_valueBodyTemplate = (reservation) => {
        if (reservation.discount_value > 0) {
                return (
                        <p>{Intl.NumberFormat("en-US").format(reservation.discount_value) + " د.ل"} </p>
                );
        }
        else {
                return <></>;
        }

};
export const DateCreate_BodyTemplate = (reservation) => {
        return (
                <p>
                        {before_days(reservation.date_create)}
                        <br></br>
                        {moment(reservation.date_create).format("LT")}
                </p>
        );
};
export const DateUpdate_BodyTemplate = (reservation) => {
        return (
                <p>
                        {reservation.date_update ? before_days(reservation.date_update) : before_days(reservation.date_del_reservation)}
                        <br></br>
                        {reservation.date_update !== "" ? moment(reservation.date_update).format("LT") : moment(reservation.date_del_reservation).format("LT")}
                </p>
        );
};
export const statusBodyTemplate = (reservation) => {
        if (reservation.total_price - reservation.total_paid === 0) {
                return <Tag style={{ fontFamily: "Cairo", direction: "rtl", fontSize: "15px" }}
                        value={"مدفوع"} severity="success">
                </Tag>;
        }
        else {
                return <Tag style={{ fontFamily: "Cairo", direction: "rtl", fontSize: "15px" }}
                        value={reservation.total_price - reservation.total_paid + " د.ل"} severity="danger">
                </Tag>;
        }
};

export const View_Img_bracelet = (bracelet) => {
        return (
                <>
                        <img src={bracelet_img} alt={`bracelet_${bracelet?.bracelet_number}`} style={{ objectFit: "cover", height: "80px" }} />
                </>
        );
};
export const View_active_bracelet = (bracelet) => {
        return (
                <>
                        <Badge value="فعــــال" severity="success" className="h" />
                </>
        );
};
export const View_created_at = (item) => {
        return <p>

                {moment(item.created_at).format("HH:mm / MM-DD")}
        </p>;
};
export const ApartmentBodyTemplate = (reservation) => {
        return (
                <>
                        {reservation?.reservation_type == 'service' ?
                                <>{reservation?.service_name_ar}</>
                                :
                                <>
                                        {view_apartment_type_ar(reservation) + "-" + reservation.number + " "}
                                </>
                        }
                        <br></br>
                        {reservation?.number_people} أشخاص
                </>
        );
};
export const View_number_people = (reservation) => {
        return <>  {reservation.number_people} <i className="pi pi-users"></i></>;
};
export const View_price_day = (reservation) => {
        return reservation.price_day + " د.ل";
};
export const View_count_days = (reservation) => {
        var days = count_days([{
                date_check_in: reservation.date_check_in,
                date_check_out: reservation.date_check_out
        }]);
        switch (days) {
                case 1:
                        return 'يوم';
                case 2:
                        return 'يومين';

                default:
                        return days + "ايام"
        }
};
const Completionist = () => <span>تم الغاء الحجز</span>;
const renderer = ({ hours, minutes, seconds, completed }) => {
        if (completed) {
                // Render a completed state
                return <Completionist />;
        } else {
                // Render a countdown
                return <span>
                        {hours}:{minutes}:{seconds}

                </span>;
        }
};
export const ID_reservationBodyTemplate = (reservation) => {
        var diffInMs = new Date(moment(reservation.date_del_reservation).format("yyyy-MM-DD")) - new Date(moment(new Date()).format("yyyy-MM-DD"));
        var diffInDays = diffInMs / (1000 * 60 * 60 * 24);
        return (
                <>
                        {reservation.ID_reservation}

                        {

                                reservation.date_del_reservation ?
                                        <span style={{ color: "red" }}>
                                                <br></br>
                                                <Countdown date={reservation.date_del_reservation}
                                                        renderer={renderer}
                                                >
                                                </Countdown>
                                                <br></br>
                                                {diffInDays > 0 ? diffInDays + " آيــام " : null}
                                        </span>
                                        : null
                        }
                </>
        );
};